<template>
    <div class="login">
      <h3 class="blank-header primary--text">LOGIN</h3>
      <v-flex>

        <v-form @keyup.native.enter="submit">
          <v-alert
                  v-if="message"
                  :value="message.length"
                  :type="message.type"
                  class="mb-3"
          >
            <div v-html="message.message"></div>
          </v-alert>
          <v-text-field
                  v-model="email"
                  type="email"
                  :error-messages="emailErrors"
                  label="E-mail"
                  required
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
          ></v-text-field>
          <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-2"
                  label="Password"
                  hint="At least 6 characters"
                  value=""
                  class="input-group--focused"
                  @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-form>

        <v-btn color="primary" @click="submit">Login</v-btn>
        <!--<v-card-text>Don't have an account?<br>
          Click <router-link to="register">here</router-link> to register</v-card-text>
        <v-card-text>Forgot your Password?<br>
          Click <router-link to="forgot">here</router-link> reset</v-card-text>-->
      </v-flex>
      <!--
          <v-form>
            <v-alert
                    v-if="message"
                    :value="message"
                    :type="message.type"
                    class="mb-3"
            >
              <div v-html="message.message"></div>
            </v-alert>
            <v-text-field
                    v-model="email"
                    :error-messages="emailErrors"
                    label="E-mail"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
            ></v-text-field>
            <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.min]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-2"
                    label="Password"
                    hint="At least 6 characters"
                    value=""
                    class="input-group--focused"
                    @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-form>
          -->

      <v-footer color="none" fixed justify-center>
        <v-container justify-center>
            <v-flex class="xs12 sm6 lg4 mx-auto" justify-center>
                <v-layout>
                    <router-link to="register" class="footer-link">Not Registered?</router-link>
                    <v-spacer></v-spacer>
                    <router-link to="forgot" class="footer-link">Forgot Password?</router-link>
                </v-layout>
            </v-flex>
        </v-container>
      </v-footer>

    </div>

</template>

<script>

  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  import { mapState } from 'vuex'

  export default {
    mixins: [validationMixin],

    validations: {
      name: {required, maxLength: maxLength(10)},
      email: {required, email},
      select: {required},
      checkbox: {
        checked(val) {
          return val
        }
      }
    },

    data: () => ({
      name: '',
      email: '',
      showPassword: false,
      password: '',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters'
      }
    }),

    computed: {
      ...mapState({
        message: state => state.global.message
      }),
      emailErrors() {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      }
    },
    methods: {
      submit() {
        this.$v.$touch()
        if(this.emailErrors.length !== 0) return
        this.$store.dispatch('auth/login',{email: this.email, password: this.password})
      }
    }
  }
</script>

<style scoped lang="scss">
  .login {
    width: 100%;
  }

</style>
